/* Mobile filter/sort bottom sheet.
   On mobile the filter bar (.facet-bar — slab facets OR porcelain Finish/Avail/Sort)
   is styled as an off-canvas bottom sheet. This injects the trigger button, backdrop,
   sheet header (grip + title + close) and footer ("Show Results"), and wires open/close.
   The filter controls themselves are untouched, so the existing filter JS keeps working. */
(function () {
  'use strict';
  var bar = document.querySelector('.facet-bar');
  if (!bar) return; // no filter bar on this page (e.g. exterior/tile) → no trigger

  // Trigger button (placed where the bar sat in the flow)
  var toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'mobile-filter-toggle';
  toggle.innerHTML =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
    '<line x1="3" y1="7" x2="21" y2="7"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="17" x2="21" y2="17"/>' +
    '<circle cx="9" cy="7" r="2.3" fill="var(--c-white)"/><circle cx="15" cy="12" r="2.3" fill="var(--c-white)"/><circle cx="8" cy="17" r="2.3" fill="var(--c-white)"/>' +
    '</svg> Filter &amp; Sort';
  bar.parentNode.insertBefore(toggle, bar);

  // Stuck-state detection: a 1px sentinel just above the toggle. When it scrolls
  // out of the viewport the toggle is pinned at top:0 → add a separating shadow.
  var sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.height = '1px';
  toggle.parentNode.insertBefore(sentinel, toggle);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      toggle.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(sentinel);
  }

  // Backdrop
  var overlay = document.createElement('div');
  overlay.className = 'filter-overlay';
  document.body.appendChild(overlay);

  // Sheet header (grip + title + close)
  var head = document.createElement('div');
  head.className = 'facet-bar__sheet-head';
  head.innerHTML =
    '<span class="facet-bar__sheet-grip"></span>' +
    '<div class="facet-bar__sheet-titlerow">' +
    '<span class="facet-bar__sheet-title">Filter &amp; Sort</span>' +
    '<button type="button" class="facet-bar__sheet-close" aria-label="Close">&times;</button>' +
    '</div>';
  bar.insertBefore(head, bar.firstChild);

  // Sheet footer (Show Results)
  var foot = document.createElement('div');
  foot.className = 'facet-bar__sheet-foot';
  foot.innerHTML = '<button type="button" class="btn">Show Results</button>';
  bar.appendChild(foot);

  function open() {
    bar.classList.add('is-open');
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    bar.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  toggle.addEventListener('click', open);
  overlay.addEventListener('click', close);
  head.querySelector('.facet-bar__sheet-close').addEventListener('click', close);
  foot.querySelector('.btn').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
